const namespace = "psct";
import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "PSCT",
  description: null,
  namespace,
  version: "0.1.1",
  icon: "mdi-home",
  accentColor: "#009CDE",
  parentRoute: "/",
  defaultRoute : "region",
  childRoutes,
  component: () => import( /* webpackChunkName: "home-parent" */ "@/apps/psct/Application.vue"),
  navigation: [{
    title: "Hello World",
    route: "helloworld",
    icon: "mdi-hand",
  },
  {
    title: "Todo List",
    route: "todolist",
    icon: "mdi-help-circle",
  },
  {
    title: "Config",
    route: "configuration",
    icon: "mdi-hammer-wrench",
  },
],
  settings : {
    
   apiUrl: "https://as-psct-api-dev.azurewebsites.net/api",
  //   apiUrl: "https://api.nonprd.lyb.com/external/psct-dev/v1/api",
    clientId: "e741c5f7-e071-46d6-ad16-e2f68ca3bf75",
    scope: "api://e741c5f7-e071-46d6-ad16-e2f68ca3bf75/Read.All",
    authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + '/')}`,
  // clientId: "94665c71-00ab-42cc-a150-77377d064292", //stg
   // scope: "api://94665c71-00ab-42cc-a150-77377d064292/Read.All", //stg
    // clientId: "38f1b253-537f-4d01-8f87-58726a6c6621",
    //  scope: "api://38f1b253-537f-4d01-8f87-58726a6c6621/Read.All",
    //  authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    //  tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    //  logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    
   // redirect_uri: window.location.origin,
  //  ui_myApp_apiUrl: "https://as-psct-api-dev.azurewebsites.net/api",
  },
  store : {
    userDetails: {
      default: {},
      storageMod: localStorage,
    }
  },

}

export default AppConfig.merge(appConfig);
